import {
  Box,
  Button,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import useTitle from "hooks/useTitle";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { ResType } from "types";
import { useQuery } from "react-query";
import { styled } from "@mui/system";
import Loader from "components/Loader";
import { getIncomeTaxEproceedingNotice } from "api/services/automation/income-tax";
import moment from "moment";
import AccessDenied from "./Access/accessDenide";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Add } from "@mui/icons-material";
import UploadAttachmentModal from "./fya/UploadAttachmentModal";
import AttachmentDisplay from "./AttachmentDisplay";
import CreateNoticeResponse from "./fya/CreateNoticeResponse";
import NoticeResponse from "./eProceedingNotice/NoticeResponse";
import CreateManualDueDate from "./fya/CreateManualDueDate";
import AttachmentAISummary from "components/AttatchmentAISummary";

interface StyledSpanProps {
  bgColor?: string; // Define bgColor prop here
}

const StyledSpan = styled("span")<StyledSpanProps>(({ theme, bgColor }) => ({
  backgroundColor: bgColor || "#ffffff",
  padding: "3px",
  fontSize: "16px",
  fontWeight: "500",
  borderRadius: "5px",
  color: "#222222",
}));

function FYANoticeView() {
  useTitle("Atom Pro");
  const params = useParams();
  const [state, setInitialState] = useState<any>({});
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const [openCreate, setOpenCreate] = useState(false)
  const [openCreateDueDate, setOpenCreateDueDate] = useState(false)

  const { data, isLoading: demandIsLoading, isFetching }: ResType = useQuery(
    ["e-proceeding-notice", params.itemId],
    getIncomeTaxEproceedingNotice,
    {
      onSuccess: (res) => {
        setInitialState(res?.data);
      },
    }
  );

  const generateAssessmentYear = (assessmentYear) => {
    if (!assessmentYear || assessmentYear === "0" || assessmentYear === "") {
      return "NA";
    } else if (!isNaN(assessmentYear) && assessmentYear.length === 4) {
      const year = parseInt(assessmentYear);
      const nextYear = (year + 1).toString().slice(-2);
      return `AY ${year}-${nextYear}`;
    } else {
      return assessmentYear;
    }
  };

  const handleItemClick = (fileName, type) => {
    const urlStart = `https://vider-prod-bucket.s3.ap-south-1.amazonaws.com/`;
    const amazon = type == "AMAZON" || type == null;
    const bharachCloud = type == "BHARATHCLOUD" || type == null;
    const url = amazon
      ? urlStart + fileName
      : bharachCloud
        ? `${fileName["endPoint"]}/${fileName["key"]}`
        : fileName?.key;
    window.open(url);
    // onDoubleClick={() => window.open(data?.webUrl ?? data?.fileUrl)}
  };


  const getFileName = (filePath, type) => {
    // Split the filePath by '/' and get the last part which is the file name
    if (type == "AMAZON" || type == null) {
      const parts = filePath.split("/");
      return parts[parts.length - 1];
    } else if (type == "MICROSOFT" || type == "GOOGLE") {
      const parts = filePath["name"].split("/");
      return parts[parts.length - 1];
    } else if (type == "BHARATHCLOUD") {
      const parts = filePath["key"].split("/");
      return parts[parts.length - 1];
    }
    return null;
  };

  const renderGridItem = (label: string, value: any) => (
    <>
      <Grid item xs={4}>
        <Typography variant="h6">{label}</Typography>
      </Grid>
      <Grid item xs={1}>
        <Typography variant="h6">:</Typography>
      </Grid>
      <Grid item xs={7}>
        <Typography>{value != null ? value : "--"}</Typography>
      </Grid>
    </>
  );


  if (demandIsLoading || isFetching) return <Loader />;
  return (
    <>
      {!state && <AccessDenied />}
      {state && (
        <>
          <Box display="flex" flexDirection="row" justifyContent="space-between" m={1}>
            <IconButton onClick={() => navigate(-1)}>
              <ArrowBackIcon fontSize="small" />
              <Typography variant="subtitle2" ml={1}>
                Notices
              </Typography>
            </IconButton>
            <Box display="flex" gap={1}>
              <Button onClick={() => setOpenCreate(true)} variant="outlined" >Create Response</Button>
              <Button onClick={() => setOpenCreateDueDate(true)} variant="contained">Add / Edit Due date</Button>
            </Box>
          </Box>

          <Box height="75vh" overflow="auto" mb={3}>
            <Grid container spacing={3}>
              <Grid item xs={6}>
                <Grid container spacing={1} pl={2} pr={2}>
                  {renderGridItem("Client Name", state?.client?.displayName)}
                  {renderGridItem("Proceeding Name", state?.proceedingName)}
                  {renderGridItem("Name Of Assesse", state?.nameOfAssesse)}
                  {renderGridItem("DIN", state?.documentIdentificationNumber)}
                  {renderGridItem("Reference Id", state?.documentReferenceId)}
                  {renderGridItem("PAN", state?.pan)}
                  {renderGridItem(
                    "Assessment Year",
                    `${generateAssessmentYear(state?.assesmentYear)}`
                  )}
                </Grid>
              </Grid>
              <Grid item xs={6}>
                <Grid container spacing={1} pl={2} pr={2}>
                  {renderGridItem(
                    "Notice Section",
                    `${state?.noticeSection ? state?.noticeSection : "--"}`
                  )}
                  {renderGridItem(
                    "Response Due Date",
                    `${state?.responseDueDate
                      ? moment(state.responseDueDate).format("DD MMM YYYY")
                      : "--"
                    }`
                  )}
                  {renderGridItem("ITR Type", `${state?.itrType ? state?.itrType : "--"}`)}
                  {renderGridItem(
                    "Issued On",
                    `${state?.issuedOn ? moment(state?.issuedOn).format("DD MMM YYYY") : "--"}`
                  )}
                  {renderGridItem("Type", `${state?.eProceeding?.proceedingType}`)}
                  {renderGridItem("Created Type", state?.createdType === "MANUAL" ? <StyledSpan bgColor="#f2e6ff">Manual</StyledSpan> : <StyledSpan bgColor="#b3ecff">Portal</StyledSpan>)}
                  {renderGridItem(
                    "Manual Due Date",
                    `${state?.manualDueDate ? moment(state?.manualDueDate).format("DD MMM YYYY") : "--"}`
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Box>
              <Box display="flex" p={1} pl={2} pr={2} pb={2}>
                <Typography sx={{ color: "#2F2F2F", fontWeight: 600 }} variant="body2">
                  Description :
                </Typography>
                <Typography>
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{ backgroundColor: "#EAFFE7", fontWeight: 600 }}
                  >
                    {state?.description}
                  </Box>
                </Typography>
              </Box>
               <Box px={2} sx={{ backgroundColor: "#F6F6F6" }} display='flex' justifyContent='space-between'>
                <Grid>
                    <Typography variant="subtitle2">Notice/Letter</Typography>
                </Grid>
                {state?.noticeLetters?.length > 0 && <Grid>
                    <AttachmentAISummary notice={state} />
                </Grid>}
              </Box>
              {state?.createdType === "MANUAL" && (<>
                <Button startIcon={<Add />} onClick={() => setOpen(true)} color="secondary">
                  Add Attachments
                </Button>
              </>)}

              {state?.storage && state?.storage?.length > 0 && (<>
                <Grid item xs={12}>
                  <AttachmentDisplay data={state?.storage} />
                </Grid>
              </>)}

              {state.noticeLetters &&
                state?.noticeLetters.map((detail: any, index: number) => (
                  <Box display="flex" textAlign="center">
                    <Typography style={{ padding: "5px", margin: "5px" }}>{index + 1}.</Typography>
                    <div
                      key={index}
                      style={{
                        cursor: "pointer",
                        padding: "5px",
                        margin: "5px",
                        border: "1px solid #ccc",
                        borderRadius: "5px",
                        color: "blue",
                      }}
                      onClick={() => handleItemClick(detail, state.storageSystem)}
                    >
                      {getFileName(detail, state.storageSystem)}
                    </div>
                  </Box>
                ))}
              <Box padding={1} sx={{ backgroundColor: "#F6F6F6" }}>
                <Typography variant="subtitle2">Notice Response</Typography>
              </Box>


              {state?.responses && <>
                <NoticeResponse responses={state?.responses} />
              </>}
            </Box>
          </Box>
          <CreateNoticeResponse open={openCreate} setOpen={setOpenCreate} state={state} />
          <UploadAttachmentModal open={open} setOpen={setOpen} type="FyaNotice" />
          <CreateManualDueDate open={openCreateDueDate} setOpen={setOpenCreateDueDate} notice={state} type="FYA" />

        </>
      )}
    </>
  );
}

export default FYANoticeView;
